import * as CatalogueModule from './catalogue/catalogue.module';
import * as ProductModule from './product/product.module';
import * as VariantModule from './variant/variant.module';
import { PermissionHelperService } from '../../services/permissionHelpers.service';


export const initialise = () => {
  CatalogueModule.initialise();
  ProductModule.initialise();
  VariantModule.initialise();

  angular.module('actora.catalogue', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',

    'ui.router.upgrade',
    'app.catalogue',
    'app.product',
    'app.variant'
  ]).constant('catalogueConstants', {
    STATUSES: [
      'DRAFT',
      'AWAITING_AUTHORISATION',
      'AUTHORISED',
      'LIVE',
      'EXPIRED'
    ],
    CHANNELS: [
      { name: 'IN_STORE', translation: 'CHANNEL_DETAIL.IN_STORE', value: false },
      { name: 'RAIL_TVM', translation: 'CHANNEL_DETAIL.RAIL_TVM', value: false },
      { name: 'RAIL_TOD', translation: 'CHANNEL_DETAIL.RAIL_TOD', value: false },
      { name: 'KIOSK', translation: 'CHANNEL_DETAIL.KIOSK', value: false },
      { name: 'MOBILE', translation: 'CHANNEL_DETAIL.MOBILE', value: false },
      { name: 'WEB', translation: 'CHANNEL_DETAIL.WEB', value: false }
    ]
  })
    .constant('catalogueStatusConstants', {
      DRAFT: 'DRAFT',
      AWAITING_AUTHORISATION: 'AWAITING_AUTHORISATION',
      AUTHORISED: 'AUTHORISED',
      LIVE: 'LIVE',
      EXPIRED: 'EXPIRED'
    })
    .factory('permissionHelpers',
      ['catalogueStatusConstants',
        (catalogueStatusConstants) => {
          return new PermissionHelperService(catalogueStatusConstants);
        }]);
}
